<template>
  <SimpleModal :is-shown="isShown" @click-overlay="handleClickOverlay">
    <p class="text">
      {{
        companyName
      }}のメンバーになりました。サービス設定から企業アカウントに切り替える事が出来ます
    </p>
    <div class="image">
      <img src="~/assets/images/capture/switchable-corporation-account.png" />
    </div>
    <div class="bottom">
      <ConversionButton
        text="閉じる"
        color="sub"
        is-inline-block
        @click="navigate"
      ></ConversionButton>
    </div>
  </SimpleModal>
</template>

<script>
import Vue from "vue"
import SimpleModal from "~/components/guideline/modal/SimpleModal.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"

export default Vue.extend({
  components: {
    SimpleModal,
    ConversionButton,
  },
  props: {
    isShown: {
      type: Boolean,
      required: true,
    },
    companyName: {
      type: String,
      required: true,
    },
  },
  methods: {
    navigate() {
      this.$emit("click-navigation-button")
    },
    handleClickOverlay() {
      this.$emit("click-overlay")
    },
  },
})
</script>

<style lang="scss" scoped>
.text {
  font-size: 14px;
  margin-bottom: 21px;

  @include mq-up {
    font-size: 16px;
    margin-bottom: 32px;
  }
}

.image {
  text-align: center;
  margin-bottom: 32px;

  @include mq-up {
    margin-bottom: 42px;
  }
}

.bottom {
  text-align: right;
}
</style>
